module.exports = __webpack_public_path__ + "img/target-2.023ba3e2.png";